import { ACESFilmicToneMapping, PCFSoftShadowMap, SRGBColorSpace, WebGLRenderer } from 'three';

/** Creates the WebGL renderer and keeps it sized to the window. */
export interface RendererHandle {
  renderer: WebGLRenderer;
  /** Re-apply the size with a new pixel ratio cap (quality tiers). */
  setPixelRatioCap(cap: number): void;
}

export function createRenderer(canvas: HTMLCanvasElement, onResize: (aspect: number) => void): RendererHandle {
  const renderer = new WebGLRenderer({ canvas, antialias: true, powerPreference: 'high-performance' });
  renderer.outputColorSpace = SRGBColorSpace;
  renderer.toneMapping = ACESFilmicToneMapping;
  renderer.toneMappingExposure = 0.82;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = PCFSoftShadowMap;

  let cap = 2;
  const resize = (): void => {
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, cap));
    renderer.setSize(window.innerWidth, window.innerHeight, false);
    onResize(window.innerWidth / window.innerHeight);
  };
  window.addEventListener('resize', resize);
  resize();
  return {
    renderer,
    setPixelRatioCap(next: number) {
      cap = next;
      resize();
    },
  };
}
